import React from "react"

const FinanceIcon = ({ color = "#8B909A", size = 18, className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className}`}
    >
      <rect
        x="1"
        y="12.9062"
        width="12.182"
        height="3.87611"
        rx="1.93805"
        fill="white"
        stroke="currentColor"
      />
      <rect
        x="3.21484"
        y="1"
        width="12.182"
        height="3.87611"
        rx="1.93805"
        stroke="currentColor"
      />
      <rect
        x="1"
        y="4.87695"
        width="12.182"
        height="3.87611"
        rx="1.93805"
        stroke="currentColor"
      />
      <rect
        x="2.66016"
        y="8.75195"
        width="12.182"
        height="3.87611"
        rx="1.93805"
        stroke="currentColor"
      />
      <ellipse
        cx="14.4216"
        cy="12.4906"
        rx="6.50165"
        ry="6.50822"
        fill="white"
        stroke="currentColor"
      />
      <path
        d="M14.4569 16.7597C14.2926 16.7597 14.1537 16.7018 14.0404 16.5859C13.9271 16.47 13.8704 16.3252 13.8704 16.1513V15.5081L14.1254 15.7428C13.7458 15.7254 13.4171 15.6762 13.1395 15.5951C12.8618 15.5139 12.6352 15.4328 12.4595 15.3517C12.3122 15.2822 12.2074 15.1837 12.145 15.0562C12.0884 14.9287 12.0657 14.7983 12.0771 14.665C12.0941 14.5318 12.1422 14.4101 12.2215 14.3C12.3009 14.1899 12.4029 14.1175 12.5275 14.0827C12.6578 14.0421 12.808 14.0595 12.978 14.1349C13.0913 14.1986 13.2613 14.2652 13.4879 14.3348C13.7203 14.3985 14.0064 14.4304 14.3464 14.4304C14.5844 14.4304 14.7713 14.4072 14.9073 14.3608C15.049 14.3145 15.1482 14.2536 15.2048 14.1783C15.2671 14.0972 15.2983 14.0103 15.2983 13.9176C15.2983 13.8306 15.2756 13.7582 15.2303 13.7003C15.1906 13.6365 15.1227 13.5815 15.0263 13.5351C14.93 13.483 14.7968 13.4366 14.6269 13.3961L13.6664 13.1875C13.1395 13.0658 12.7457 12.863 12.485 12.579C12.23 12.2893 12.1025 11.9156 12.1025 11.4578C12.1025 11.1101 12.1847 10.8001 12.349 10.5278C12.519 10.2497 12.7542 10.0237 13.0545 9.84985C13.3605 9.67602 13.7174 9.56592 14.1254 9.51957L13.8704 9.66732V9.08498C13.8704 8.91115 13.9271 8.76629 14.0404 8.6504C14.1537 8.53451 14.2926 8.47656 14.4569 8.47656C14.6269 8.47656 14.7685 8.53451 14.8818 8.6504C14.9952 8.76629 15.0518 8.91115 15.0518 9.08498V9.66732L14.7968 9.50218C15.0122 9.50798 15.2445 9.54564 15.4938 9.61517C15.7431 9.67891 15.9613 9.76873 16.1482 9.88462C16.2786 9.95415 16.3692 10.0498 16.4202 10.1714C16.4769 10.2931 16.4967 10.4177 16.4797 10.5452C16.4684 10.6669 16.4231 10.777 16.3437 10.8755C16.2701 10.974 16.1681 11.0406 16.0378 11.0754C15.9131 11.1044 15.7629 11.0812 15.5873 11.0058C15.457 10.9479 15.3096 10.9015 15.1453 10.8668C14.9867 10.8262 14.7827 10.8059 14.5334 10.8059C14.2331 10.8059 14.0007 10.861 13.8364 10.9711C13.6778 11.0812 13.5984 11.2231 13.5984 11.397C13.5984 11.5129 13.6438 11.6114 13.7344 11.6925C13.8308 11.7678 14.0036 11.8345 14.2529 11.8924L15.2218 12.1097C15.7601 12.2314 16.1567 12.4342 16.4117 12.7181C16.6724 12.9962 16.8027 13.3584 16.8027 13.8046C16.8027 14.1522 16.7205 14.4593 16.5562 14.7259C16.3919 14.9924 16.1624 15.2097 15.8678 15.3778C15.5788 15.5458 15.2416 15.6559 14.8563 15.7081L15.0518 15.4995V16.1513C15.0518 16.3252 14.9952 16.47 14.8818 16.5859C14.7742 16.7018 14.6325 16.7597 14.4569 16.7597Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default FinanceIcon
